// Browser-only Firebase client loader.
// Uses dynamic imports so Firebase is code-split and doesn't bloat the initial bundle.

let appPromise;
let authPromise;
let dbPromise;

function assertBrowser() {
  if (typeof window === "undefined") {
    throw new Error("firebaseClient: called on the server");
  }
}

function getFirebaseConfig() {
  return {
    apiKey: process.env.NEXT_PUBLIC_FIREBASE_API_KEY,
    authDomain: process.env.NEXT_PUBLIC_FIREBASE_AUTH_DOMAIN,
    projectId: process.env.NEXT_PUBLIC_FIREBASE_PROJECT_ID,
    storageBucket: process.env.NEXT_PUBLIC_FIREBASE_STORAGE_BUCKET,
    messagingSenderId: process.env.NEXT_PUBLIC_FIREBASE_MESSAGING_SENDER_ID,
    appId: process.env.NEXT_PUBLIC_FIREBASE_APP_ID,
    measurementId: process.env.NEXT_PUBLIC_FIREBASE_MEASUREMENT_ID,
  };
}

export async function getFirebaseApp() {
  assertBrowser();

  if (!appPromise) {
    appPromise = (async () => {
      const { initializeApp, getApp, getApps } = await import("firebase/app");
      const cfg = getFirebaseConfig();
      return getApps().length ? getApp() : initializeApp(cfg);
    })();
  }

  return appPromise;
}

export async function getFirebaseAuth() {
  assertBrowser();

  if (!authPromise) {
    authPromise = (async () => {
      const app = await getFirebaseApp();
      const { getAuth, setPersistence, browserLocalPersistence } = await import(
        "firebase/auth"
      );

      const auth = getAuth(app);
      // Best-effort; persistence can fail in some browser privacy modes.
      try {
        await setPersistence(auth, browserLocalPersistence);
      } catch {
        // ignore
      }

      return auth;
    })();
  }

  return authPromise;
}

export async function getFirestoreDb() {
  assertBrowser();

  if (!dbPromise) {
    dbPromise = (async () => {
      const app = await getFirebaseApp();
      const { getFirestore } = await import("firebase/firestore");
      return getFirestore(app);
    })();
  }

  return dbPromise;
}

